import * as Backbone from "backbone";
import {BaseInternalView, BaseInternalViewOptions} from "../../_BaseViews";
import {ReportsCollection} from "../../../collections/Reports";
import {UserCollection} from "../../../collections/Users";

export interface BaseEditViewOptions extends BaseInternalViewOptions {
}

export interface BaseEditSubViewOptions extends BaseEditViewOptions {
    reportsCollection: ReportsCollection;
    report: Backbone.Model;
    userCollection?: UserCollection;
    category: string;
    orgId: number;
}

export class BaseEditSubView extends BaseInternalView {

    options: BaseEditSubViewOptions;

    constructor(options: BaseEditSubViewOptions) {
        super(<any> options);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/reports/editReports/_BaseEditView.ts